const TextArrayContainer = ({ label, content }) => {
  return (
    <>
      {content && (
        <div className="w-full flex-1">
          <div className="px-2 text-text-1">
            <h5 className="py-1 text-nowrap font-lato font-semibold">
              {label}
            </h5>
            {content.map(({ name, number }, index) => (
              <p key={index} className="text-text-1/85 pl-3">
                <span className="text-text-1">
                  {++index}
                  {". "}
                </span>
                {name}
              </p>
            ))}
          </div>
        </div>
      )}
    </>
  );
};

export default TextArrayContainer;
